import { useMemo } from 'react'
import { useStableArray } from '../array/useStableArray'

export function useStableObject<Obj extends object>(obj: Obj = {} as Obj) {
  const stableKeys = useStableArray(Object.keys(obj))
  const stableVals = useStableArray(Object.values(obj))

  return useMemo(() => obj, [stableKeys, stableVals])
}
